module.exports = __webpack_public_path__ + "84fd19d366d2832ea9fa9b6b05420dc8.png";